import { appApi } from "../api";
import { Paginated } from "@/@types/generics/paginated";
import { Permission } from "@/@types/app/Permission";

export async function getAllPermissions(roleId: number, pageNumber: number, pageSize?: number) {
	const { data } = await appApi.get<Paginated<Permission>>(`/permission/paginated`, {
		roleId: roleId,
		pageNumber: pageNumber,
		pageSize: pageSize || 10,
	});
	return data || ({} as Paginated<Permission>);
}
